// extracted by mini-css-extract-plugin
export default {"topNotify":"list_topNotify__zInCV","active":"list_active__hbleR","notificationList":"list_notificationList__32kCS","loading":"list_loading__iUv2z"};